import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAccount } from 'wagmi';
import { api as blinkoApi } from '~/blinko/api';
import Loader from '~/core/components/Loader';
import { profileCache } from '~/blinko/components/ProfileSlot';
import { useToast } from '~/core/contexts/ToastContext';
import { twitterAuthRedirectStorage } from '~/core/storages';

export const TwitterCallback = () => {
  const navigate = useNavigate();
  const { address } = useAccount();
  const toast = useToast()

  const [searchParams] = useSearchParams();

  useEffect(() => {
    (async () => {
      const oauthToken = searchParams.get('oauth_token');
      const oauthVerifier = searchParams.get('oauth_verifier');

      if (!oauthToken || !oauthVerifier) {
        toast.error('Missing OAuth parameters');
        navigate('/', { replace: true });
        return;
      }

      try {
        await blinkoApi.authorizeTwitter(address!, oauthToken, oauthVerifier);
        profileCache.update(address!);
        toast.success('Successfully connected to 𝕏');
      } catch (error) {
        console.error('𝕏 account connection failed', error);
        toast.error('𝕏 account connection failed');
      } finally {
        const redirect = twitterAuthRedirectStorage.get()
        if (redirect) {
          twitterAuthRedirectStorage.remove()
          navigate(redirect, { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      }
    })()
  }, [searchParams]);

  return (
    <div className="flex justify-center items-center w-full h-svh">
      <div className="flex flex-col gap-4 justify-center items-center">
        <Loader size="32px" stroke="#2b2a2f" />
        <p>
          Connecting to 𝕏...
        </p>
      </div>
    </div>
  );
};
